import ToastComponent from "./toast.vue";
const Toast = {};
Toast.install = (Vue, options) => {
  let opt = {
    position: "middle", // 默认显示位置  top, middle, bottom
    duration: "2500", // 持续时间
    type: "text" // 类型  可选值 success, warn, cancel, text
  };
  let defaultOpt = Object.assign({}, opt, options);
  /**
   * @method 注册插件
   * @param {Function} Vue构造器
   */
  const ToastConstructor = Vue.extend(ToastComponent);
  const instance = new ToastConstructor(); // 创建子实例
  instance.$mount(document.createElement("div"));
  document.body.appendChild(instance.$el);
  /**
   *
   *添加实例方法，全局注册
   * @param {*} msg 内容
   * @param {*} type 类型，默认text success, warn, cancel, text
   * @param {*} duration 持续时间 默认2000ms
   * @param {*} position 位置 top, middle, bottom
   */
  Vue.prototype.$toast = options => {
    instance.show = true;
    let obj;
    if (typeof options === "object") {
      obj = options;
    } else if (typeof options === "string") {
      obj = {
        msg: options
      };
    }
    let newOpt = Object.assign({}, defaultOpt, obj);
    for (let property in newOpt) {
      instance[property] = newOpt[property]; // 使用 options 的配置
    }
  };
  // 编写相应的快捷方法
  ["bottom", "top", "middle"].forEach(position => {
    Vue.prototype.$toast[position] = options => {
      let newOpt = "";
      if (typeof options === "object") {
        newOpt = Object.assign({}, defaultOpt, options, {
          position: position
        });
      } else if (typeof options === "string") {
        newOpt = Object.assign({}, defaultOpt, {
          position: position,
          msg: options
        });
      }
      return Vue.prototype.$toast(newOpt);
    };
  });
  ["text", "success", "warn", "cancel"].forEach(type => {
    Vue.prototype.$toast[type] = options => {
      let newOpt = "";
      if (typeof options === "object") {
        newOpt = Object.assign({}, defaultOpt, options, {
          type: type
        });
      } else if (typeof options === "string") {
        newOpt = Object.assign({}, defaultOpt, {
          type: type,
          msg: options
        });
      }
      return Vue.prototype.$toast(newOpt);
    };
  });
  Vue.prototype.$toast.hide = () => {
    instance.show = false;
  };
};
export default Toast;
